// import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import Articles from './Articles';
import Article from './Article';
import ArticleSearch from './ArticleSearch';
import Dfp from './Dfp';
import Superbanner from './Superbanner';
import Menu from './Menu';
import Insider from './Insider';
import Guestwriter from './Guestwriter';
import Authors from './Authors';
import Shegallery from './Shegallery';
import Splash from './Splash';
import TopTags from "./TopTags";

let baseURL = document.querySelector('meta[name="baseURL"]').content;
let basePATH = document.querySelector('meta[name="basePATH"]').content;
let catId = document.querySelector('meta[name="catId"]').content;
let catName = document.querySelector('meta[name="category"]')? document.querySelector('meta[name="category"]').content : '';
let postId = document.querySelector('meta[name="postId"]').content;
let theme = document.querySelector('meta[name="theme"]') ? document.querySelector('meta[name="theme"]').content : basePATH.replace(baseURL+'/wp-content/themes/','');
let author = document.querySelector('meta[name="author"]').content;
let authors = document.querySelector('meta[name="authors"]').content;
let guestwriters = (theme == 'she.com') ? document.querySelector('meta[name="guestwriters"]').content : '';
let page = document.querySelector('meta[name="page"]').content;
let subcat = document.querySelector('meta[name="subcat"]').content;
let apiLabel = document.querySelector('meta[name="apiLabel"]').content;
let menuData = [];

function trimThemeName(tmpCurTheme){
	let tmpTheme = tmpCurTheme;

	if(tmpTheme.indexOf('blog.she.com')!=-1){
		tmpTheme = tmpTheme.replace('.home','');
	}

	if(window.location.href.indexOf('facelift.she.com')!=-1){
        tmpTheme = 'facelift.she.com'
	}

	return tmpTheme;
}

if(document.getElementById('insider')){
	ReactDOM.render(
	  <Insider baseurl={baseURL} theme={theme} authors={authors} />,
	  document.getElementById('insider')
	);
}
if(document.getElementById('guestwriter')){
	ReactDOM.render(
	  <Guestwriter baseurl={baseURL} theme={theme} authors={guestwriters} />,
	  document.getElementById('guestwriter')
	);
}

if(document.getElementById('pro-blogger')){
	let elm = document.getElementById('pro-blogger');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} wrap={elm} showall={true} api={'getProBloggers'} />,
	  document.getElementById('pro-blogger')
	);
}

if(document.getElementById('hottest-blogger')){
	let elm = document.getElementById('hottest-blogger');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} wrap={elm} showall={true} api={'getHottestBloggers'} />,
	  document.getElementById('hottest-blogger')
	);
}

if(document.getElementById('assigned-authors') && authors!=''){
	let elm = document.getElementById('assigned-authors');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} authors={authors} wrap={elm} />,
	  document.getElementById('assigned-authors')
	);
}

if(document.getElementById('splash-wrapper')){
	ReactDOM.render(
	  <Splash baseurl={baseURL} theme={theme} />,
	  document.getElementById('splash-wrapper')
	);
}
if(document.getElementById('superbanner')){
	ReactDOM.render(
	  <Superbanner baseurl={baseURL} theme={theme} />,
	  document.getElementById('superbanner')
	);
}

if(document.getElementById('article-list')){
	let tmpTheme = trimThemeName(theme);
	let replaceTitle = document.getElementById('article-list').dataset;

	if(replaceTitle.hasOwnProperty('title') && replaceTitle.title != ''){
		replaceTitle = replaceTitle.title;
	}else{
		replaceTitle = 'highlights';
	}

	ReactDOM.render(
		<Articles baseurl={baseURL} theme={tmpTheme} author={author}  catId={catId} subcat={subcat} section={page} apiLabel={apiLabel} replaceTitle={replaceTitle} />,
		document.getElementById('article-list')
	);
}

if(document.getElementById('article-search-list')){
    let tmpTheme = trimThemeName(theme);
    let replaceTitle = document.getElementById('article-search-list').dataset;

    if(replaceTitle.hasOwnProperty('title') && replaceTitle.title != ''){
        replaceTitle = replaceTitle.title;
    }else{
        replaceTitle = 'highlights';
    }

	ReactDOM.render(
		<ArticleSearch baseurl={baseURL} theme={tmpTheme} author={author}  catId={catId} subcat={subcat} section={page} apiLabel={apiLabel} replaceTitle={replaceTitle} />,
		document.getElementById('article-search-list')
	);
}

if(document.getElementById('ad_300x250')){

    let tmpTheme = trimThemeName(theme);
	tmpTheme = 'she.com';

    ReactDOM.render(
        <Dfp
            adUnit={tmpTheme+'_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250'}
            sizes={[[300,250],[300,600]]}
			// dfpReady={
			// 	(tmp) => {
			// 		let adunit = {};
            //         adunit['slot1'] = googletag.defineSlot('she.com_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250', [[300, 250], 'ad_00003']).addService(googletag.pubads());
            //         adunit['slot2'] = googletag.defineSlot('she.com_' + 'channels' + '_' + 'BTF_set' +'2'+'_300x250', [[300, 250], 'ad_00003']).addService(googletag.pubads());
			// 		googletag.pubads().refresh(adunit);
            //         console.log('hihi');
			//
            //     }
            // }
		/>,
        document.getElementById('ad_300x250')
    );
}

if(document.getElementById('leaderboard')){

    let tmpTheme = trimThemeName(theme);
    tmpTheme = 'she.com';

    ReactDOM.render(
        <Dfp
            adUnit={tmpTheme+'_' + 'channels' + '_ATF_expand_970x90'}
            sizes={[[970,90],[970,550],[970,250],[728,90],[728,180],[320, 50],[320, 100],[300,250]]}
            sizeMapping={ [
                {viewport: [970, 0], sizes:[[728, 90],[728,180],[970,90],[970,250]]},
                {viewport: [0, 0], sizes:[[320, 50],[320, 100],[300,250]] }
            ]}
        />,
        document.getElementById('leaderboard')
    );
}


if(document.getElementById('fixed-menu')){
	ReactDOM.render(
		<Menu baseurl={baseURL} theme={theme} catId={catId} postId={postId}/>,
		document.getElementById('fixed-menu')
	);
}

if(document.getElementById('article-content')){
	let tmpTheme = trimThemeName(theme);

	ReactDOM.render(
	  <Article baseurl={baseURL} theme={tmpTheme} catId={catId} postId={postId} section={page}/>,
	  document.getElementById('article-content')
	);
}

if(document.getElementById('blogger-tags-box')){
	let tagmore = document.querySelector('.blogger-tag-more');
	let tagbox = document.querySelector('.blogger-tags-box');

	tagmore.onclick = function(){
		let tagmoreSpan = document.querySelectorAll('.blogger-tag-more span');
		if(tagbox.className.indexOf('showall')==-1){
			tagbox.className = tagbox.className + ' showall';
		}else{
			tagbox.className = tagbox.className.replace(' showall','');
		}

		for(let i=0; i<tagmoreSpan.length;i++){
			if(tagmoreSpan[i].className==''){
				tagmoreSpan[i].className = 'active';
			}else{
				tagmoreSpan[i].className = '';
			}
		}
	};
}

/* Tag Cloud (for PHP page) */
// page = home/category/single?
// catName) = category parent name
let isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
let popularTag = (document.getElementById('popular-tag') && document.getElementById('popular-tag').dataset) ? document.getElementById('popular-tag').dataset.tags : ((document.getElementById('popular-tag-mobile-top') && document.getElementById('popular-tag-mobile-top').dataset) ? document.getElementById('popular-tag-mobile-top').dataset.tags : '');
let tagList = popularTag? JSON.parse(popularTag) : [];

if (page == 'home' || page == 'category' || page == 'single') {
	// console.log('getTags() then ', tagList);
	if (isMobile) {
		if (document.getElementById('popular-tag-mobile-top')) {
			ReactDOM.render(
				<TopTags theme={trimThemeName(theme)} page={page} position={'top'} catName={catName} tagList={tagList}/>,
				document.getElementById('popular-tag-mobile-top')
			);
		}
		document.querySelectorAll('.popular-tag-mobile').forEach((tag_mobile, index) =>
			ReactDOM.render(
				<TopTags theme={trimThemeName(theme)} page={page} position={'side'} catName={catName} tagList={tagList}/>,
				tag_mobile)
		);
	} else {
		document.querySelectorAll('.popular-tag-desktop').forEach((tag_desktop, index) =>
			ReactDOM.render(
				<TopTags theme={trimThemeName(theme)} page={page} position={'side'} catName={catName} tagList={tagList}/>,
				tag_desktop)
		);
	}
}



// WEBPACK FOOTER //
// ./src/index.js